import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs/Rx';

import { ChangePasswordService } from './service/change-password.service';

declare var $: any;

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  user: any;
  msgInfo: string = '';
  isDisabled: boolean = false;
  pass: any;
  confirm: any;
  msgButton: string = 'Alterar';
  subscriptionPut: Subscription;

  constructor(private router: Router, private changePasswordService: ChangePasswordService, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.getParam();
  }

  goLogin() {
    this.router.navigate(['/login']);
  }

  openMsg(msg) {

    $.notify({
      icon: "pe-7s-info",
      message: msg
    }, {
        type: 'success',
        timer: 1500,
        placement: {
          from: 'bottom',
          align: 'right'
        }
      });
  }

  doChangePassword() {

    this.isDisabled = true;

    if (!this.validateField()) {
      this.isDisabled = false;
      return;
    }

    this.user.new = this.pass;
    this.user.confirm = this.confirm;

    this.subscriptionPut = this.changePasswordService.login(this.user)
      .subscribe(succ => {
        let ret: any = succ;

        if (ret.success) {
          this.openMsg(ret.messege);
          this.router.navigate(['/login']);
        }

        this.msgInfo = ret.messege;
        this.isDisabled = false;

      }, err => {
        this.isDisabled = false;
      });
  }

  ngOnDestroy() {
    if (this.subscriptionPut)
      this.subscriptionPut.unsubscribe();
  }


  private validateField() {
    this.msgInfo = "";
    if (!this.pass || !this.confirm) {
      this.msgInfo = 'Todos os campos são obrigatorios.';
      return false;

    }

    if (this.pass.length < 4) {
      this.msgInfo = 'Não é permitido menos que 4 digitos.';
      return false;
    }

    if (this.pass != this.confirm) {
      this.msgInfo = 'Os campos devem ser iguais.';
      return false;
    }

    return true;
  }

  private getParam() {

    this.activatedRoute.params.subscribe((params: Params) => {
      if (!params['id']) {
        this.router.navigate(['/login']);
      }
      try {
        this.user = JSON.parse(atob(params['id']));
      } catch (e) {
        this.router.navigate(['/login']);
      }

    });
  }

}
